import React from "react";

// Thin, low burnout wisp hugging the right rear tire of the Corvette.
// No giant plumes — just a wispy haze coming off the tire.
export default function TireSmoke({ className = "" }) {
  // Small, low, concentrated cluster directly behind the right rear tire.
  // Wisps stay close, drift slightly up and to the right.
  const puffs = [
    // Right rear tire — tight cluster
    { x: 76, y: 84, s: 110, d: 0,   t: 6,  o: 0.55 },
    { x: 78, y: 86, s: 90,  d: 1.0, t: 5.5,o: 0.6  },
    { x: 79, y: 82, s: 100, d: 2.2, t: 6.5,o: 0.5  },
    { x: 74, y: 85, s: 80,  d: 0.5, t: 5,  o: 0.5  },
    { x: 81, y: 84, s: 90,  d: 1.8, t: 6,  o: 0.45 },
    { x: 77, y: 80, s: 70,  d: 3.0, t: 5.5,o: 0.4  },
    // Thin drifters
    { x: 84, y: 80, s: 110, d: 2.5, t: 7,  o: 0.25 },
    { x: 82, y: 78, s: 90,  d: 4.0, t: 7.5,o: 0.2  },
  ];

  return (
    <div data-testid="tire-smoke" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      {puffs.map((p) => (
        <span
          key={`${p.x}-${p.y}-${p.d}`}
          className="smoke-puff"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: `${p.s}px`,
            height: `${p.s}px`,
            animationDelay: `${p.d}s`,
            animationDuration: `${p.t}s`,
            opacity: p.o,
          }}
        />
      ))}
    </div>
  );
}
